<!-- 选择课程弹窗 -->
<template>
  <div>
    <!-- 上传弹窗 -->
    <el-dialog
      :visible.sync="outerVisible"
      width="900px"
      :before-close="handleClose"
    >
      <div class="fileTitle">
        <b>任务名称</b>
        <!-- {{ fileTitle }} -->
        <el-input
          v-model="task_name"
          placeholder="请输入任务名称"
          style="width: 200px; display: inline-block; margin-left: 10px"
          @change="taskNamechange"
          :disabled="loading"
          maxlength="15"
        ></el-input>
        点击可手动修改
      </div>
      <div class="fileBox">
        <div class="fileH1">
          <el-steps :active="active" finish-status="success">
            <el-step title="上传文件"> </el-step>
            <el-step title="导入数据"></el-step>
            <el-step title="分配任务"></el-step>
          </el-steps>
        </div>
        <div v-if="active == 1">
          <div class="fileH2">
            一、请按照数据模板的格式准备要导入的数据
            <span style="color: #409eff; cursor: pointer" @click="exportExcel"
              >点击下载《客户导入模板》</span
            >
          </div>
          <div class="fileH2">
            <div class="fileH2Text">二、选择需要导入的文件</div>
            <div>
              <el-input
                placeholder="请选择文件"
                v-model="fileName"
                class="input-with-select"
              >
                <el-upload
                  style="display: inline-block; margin: 0 15px"
                  action="/上传文件的接口"
                  :on-change="onChange"
                  :auto-upload="false"
                  :show-file-list="false"
                  slot="append"
                  accept=".xls, .xlsx"
                >
                  <el-button type="success" size="small">选取文件</el-button>
                </el-upload>
              </el-input>
            </div>
          </div>
          <div class="fileH3">
            <p style="margin-bottom: 20px">注意：</p>
            <p style="margin-bottom: 20px">手机号为必填项，不允许为空</p>
            <p style="margin-bottom: 20px">
              模板中的表头名称不可更改，表头行不能删除
            </p>
            <p style="margin-bottom: 20px">一次最多上传10000条数据</p>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="excelImport" size="mini">取 消</el-button>
            <el-button type="primary" @click="importFile" size="mini"
              >确 定</el-button
            >
          </div>
        </div>
        <div v-if="active == 2">
          <div class="loadingH1" v-if="loading">
            <loadingBox></loadingBox>
          </div>
          <div class="loadingH2" v-if="!loading">
            <i class="el-icon-success pic"></i>
            <p class="title">数据导入完成</p>


            <div v-if="isImportShow&&isImportSucc&&isImportSucc>0">
              <div class="cont">
                 导入成功{{
                  isImportSucc
                }}条 

                <span
                  style="color: #409eff; cursor: pointer"
                  @click="ImportRecord"
                  >查看导入记录</span
                >
              </div> 
            </div>
            <div v-else> 
              <div class="cont">
                总数{{ returnData.total }}条， 导入成功{{
                  returnData.succ
                }}条，重复{{ returnData.repeat }}条

                <span
                  style="color: #409eff; cursor: pointer"
                  @click="ImportRecord"
                  >查看导入记录</span
                >
              </div> 
              <div
                v-if="returnData.repeat_group > 0 || returnData.repeat_excel > 0"
                class="cont"
              >
                <span style="color: red">重复说明：</span>
                <span v-if="returnData.repeat_group > 0">
                  和以往导入的数据存在重复{{ returnData.repeat_group }}条
                  <!-- （已过滤） -->
                  <el-select
                    v-model="is_import_repeat_mobile"
                    placeholder="请选择类型"
                    default-first-option
                  >
                    <!-- @change="isImportChange" -->
                    <el-option
                      v-for="item of isRepeatOptions"
                      :value="item.value"
                      :label="item.label"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </span>
                </br>
                <span v-if="returnData.repeat_excel > 0">
                  和本次导入的数据存在重复{{
                    returnData.repeat_excel
                  }}条（已过滤）
                </span>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <div v-if="is_import_repeat_mobile==1&&isImportSucc==0">
                <el-button  
                  type="primary"
                  @click="isImportChange"
                  size="mini">下一步</el-button
                  >
              </div>
              <div v-else> 
                  <el-button
                    v-if="(returnData.succ && returnData.succ > 0)||(returnData.repeat_group > 0&&is_import_repeat_mobile==1&&isImportSucc>0)"
                    type="primary"
                    @click="nextClick"
                    size="mini"
                    >下一步</el-button
                  >
                  <el-button v-else type="primary" @click="backClick" size="mini"
                    >暂无导入成功数据，请重新上传</el-button
                  >
              </div>
            </div>
          </div>
        </div>
        <div v-if="active == 3" style="min-height: 300px">
          <div>
            <div style="margin: 20px 0">
              分配拨号任务
              <el-popover placement="bottom" width="400" trigger="click">
                <el-button slot="reference" style="width: 500px">
                  <div
                    v-if="fenpei_list && fenpei_list.length > 0"
                    style="width: 500px; display: flex; flex-wrap: wrap"
                  >
                    <el-tag
                      v-for="tag in fenpei_list"
                      :key="tag.id"
                      size="medium"
                      style="
                        border-radius: 20px;
                        margin-right: 10px;
                        margin-bottom: 5px;
                      "
                    >
                      {{ tag.name }}{{ tag.num }}
                    </el-tag>
                  </div>
                  <span v-else>选择员工</span>
                </el-button>
                <div v-if="allTaskList.length > 0">
                  <div style="margin-bottom: 20px">
                    <el-radio-group
                      v-model="allotDataType"
                      size="mini"
                      @change="allotTypechange()"
                    >
                      <el-radio :label="1">自定义分配</el-radio>
                      <el-radio :label="2">选中的员工平均分配</el-radio>
                    </el-radio-group>
                  </div>
                  <div style="max-height: 300px; overflow-y: scroll">
                    <div
                      v-for="(item, index) in allTaskList"
                      :key="index"
                      style="margin-bottom: 10px"
                    >
                      <el-checkbox
                        v-model="item.selectedState"
                        @change="selectedChange(item.selectedState, index)"
                        style="
                          margin-right: 20px;
                          min-width: 90px;
                          display: inline-block;
                        "
                        >{{ item.name }}</el-checkbox
                      >
                      <el-input-number
                        v-model="item.num"
                        :disabled="!item.selectedState || item.disabled"
                        :min="0"
                        :max="item.maxNum"
                        label=""
                        @change="fenPeiChange(item)"
                        style="margin-right: 20px"
                      ></el-input-number>

                      <span v-if="item.zx_total"
                        >该员工已执行{{ item.zx_total }}个,</span
                      ><span v-if="item.jt_total"
                        >已接通{{ item.jt_total }}个</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  style="
                    text-align: center;
                    padding: 100px 0;
                    margin-bottom: 20px;
                    border: 1px solid #ddd;
                  "
                  v-else
                >
                  暂未添加员工，请点击
                  <span @click="staffAdd" style="color: #409eff">添加员工</span>
                </div>

                <div style="margin-bottom: 20px">
                  已分配<span style="color: red">{{ residue }}</span
                  >条数据，还剩<span style="color: red">{{ Remaining }}</span
                  >条待分配
                </div>
              </el-popover>
            </div>
            <div style="margin: 20px 0 120px 0; text-align: center">
              注：未分配任务的号码数据，仅管理员可见
            </div>
          </div>
          <div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submit" size="mini"
                >确 定</el-button
              >
              <el-button @click="outerVisible = false" size="mini"
                >取 消</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import callPhoneApi from "@/api/callphone";
import loadingBox from "@/components/loadingBox.vue";
export default {
  name: "ImportOwnNumber",
  components: {
    loadingBox,
  },
  props: {
    outerVisible: {
      type: Boolean,
      default: false,
    },
    task_name: {
      type: String,
      default: "text",
    },
  },
  computed: {},
  data() {
    return {
      // 读取文件
      fileData: "",
      fileName: "",
      excelList: [],
      active: 1,
      visible: false,
      loading: false,
      returnData: {},
      allTaskList: [],
      fenpei_list: [],
      Remaining: 0,
      residue: 0,
      allotDataType: 1,
      isRepeatOptions: [
        //1是 0否
        { label: "已过滤", value: 0 },
        { label: "仍需导入", value: 1 },
      ],
      is_import_repeat_mobile: 0,
      old_repeat_excel_data_list:[],
      isImportShow: false,
      isImportSucc: 0,
      onlytimestamp: "",
    };
  },
  created() {
    // this.getTobAllAcCount();
    this.fileData = "";
    this.fileName = "";
    this.excelList = [];
    this.active = 1;
    this.isImportShow = false;
    this.isImportSucc = 0;
  },
  watch: {
    // allTaskList: {
    //   handler: function (newV, oldV) {
    //     console.log("allTaskList", newV, oldV);
    //   },
    //   deep: true,
    // },
    outerVisible: {
      deep: true,
      handler: function (newV, oldV) {
        console.log("outerVisible", newV);

        this.$emit("outerRefresh", !newV);
      },
    },

    allTaskList: {
      deep: true,
      handler: function (newV, oldV) {
        console.log("allTaskList", newV);
        this.fenpei_list = [];
        var residue = 0;
        newV.forEach((item) => {
          if (item.num > 0) {
            this.fenpei_list.push(item);
            residue += item.num;
          }
        });
        this.Remaining = this.returnData.succ - residue;
        this.residue = residue;

        // this.allTaskList.forEach((item) => {
        //   item.maxNum = this.Remaining;
        // });

        this.$forceUpdate();
      },
    },
  },
  methods: {
    staffAdd() {
      this.$router.push({
        path: "/employeesManage",
      });
    },
    taskNamechange(e) {
      console.log("taskNamechange", e);
      if (this.active > 1) {
        commonApi
          .edittaskname({
            task_id: this.returnData.task_id,
            task_name: e,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "任务名称成功！",
                type: "success",
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
      }
    },
    allotTypechange() {
      console.log("allotTypechange", this.allotDataType);
      var allotNum = 0;
      if (this.allotDataType == 2) {
        var fenpeiList = this.allTaskList;
        fenpeiList.forEach((item) => {
          item.selectedState = false;
          item.disabled = true;
          if (item.num > 0) {
            item.selectedState = true;
            allotNum++;
          }
        });
        if (allotNum > 0) {
          let pingunZhi = Math.floor(this.returnData.succ / allotNum);
          let yushu = Math.floor(this.returnData.succ % allotNum);

          fenpeiList.forEach((item) => {
            if (item.selectedState) {
              item.num = pingunZhi;
              item.maxNum = pingunZhi;
            } else {
              item.num = 0;
              item.maxNum = 0;
            }
          });
          if (yushu) {
            var diyifenpeiList = fenpeiList.find((item) => item.selectedState);
            fenpeiList.forEach((item, index) => {
              if (item.id == diyifenpeiList.id) {
                fenpeiList[index].num = pingunZhi + yushu;
                fenpeiList[index].maxNum = pingunZhi + yushu;
              }
            });
          }

          // if (this.returnData.succ % allotNum) {
          //   fenpeiList[0].num = pingunZhi + yushu;
          //   fenpeiList[0].maxNum = pingunZhi + yushu;
          // }
          this.allTaskList = fenpeiList;
        }
      } else {
        this.allTaskList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.$forceUpdate(); //刷新
    },
    submit() {
      const dataAll = [];
      this.fenpei_list.forEach((item) => {
        if (item.num && item.num > 0) {
          dataAll.push({
            staff_id: item.staff_id,
            name: item.name,
            num: item.num,
          });
        }
      });
      if (dataAll.length <= 0) {
        this.outerVisible = false;
        return;
      }
      commonApi
        .tobAllot({
          task_id: this.returnData.task_id,
          type: this.allotDataType,
          data: JSON.stringify(dataAll),
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "提交分配成功！",
              type: "success",
            });
            this.outerVisible = false;
          }
        });
    },
    fenPeiChange(e) {
      // var residue = 0;
      // this.allTaskList.forEach((item) => {
      //   if (e.staff_id != item.staff_id) {
      //     residue += item.num;
      //   }
      // });
      // this.allTaskList.forEach((item) => {
      //   if (e.staff_id == item.staff_id) {
      //     item.maxNum = this.returnData.succ - residue;
      //     // item.maxNum = this.returnData.succ;
      //   }
      // });

      var residue = 0;
      this.allTaskList.forEach((item) => {
        residue += item.num;
      });

      this.allTaskList.forEach((item, index) => {
        item.maxNum = item.num + this.returnData.succ - residue;
      });
      console.log("fenpeiTotalChange1", this.allTaskList);
      this.$forceUpdate();
      // console.log("fenpeiTotalChange2", this.allTaskList);
    },
    selectedChange(value, index) {
      if (!value) {
        this.allTaskList[index].num = 0;
      }
      console.log("selectedChange", this.allTaskList, this.allotDataType);
      var allotNum = 0;
      if (this.allotDataType == 2) {
        var fenpeiList = this.allTaskList;
        fenpeiList.forEach((item) => {
          item.disabled = true;
          if (item.selectedState) {
            allotNum++;
          }
        });
        if (allotNum > 0) {
          let pingunZhi = Math.floor(this.returnData.succ / allotNum);
          let yushu = Math.floor(this.returnData.succ % allotNum);

          fenpeiList.forEach((item) => {
            if (item.selectedState) {
              item.num = pingunZhi;
              item.maxNum = pingunZhi;
            } else {
              item.num = 0;
              item.maxNum = 0;
            }
          });
          // if (this.returnData.succ % allotNum) {
          //   fenpeiList[0].num = pingunZhi + yushu;
          //   fenpeiList[0].maxNum = pingunZhi + yushu;
          // }

          if (yushu) {
            var diyifenpeiList = fenpeiList.find((item) => item.selectedState);
            fenpeiList.forEach((item, index) => {
              if (item.id == diyifenpeiList.id) {
                fenpeiList[index].num = pingunZhi + yushu;
                fenpeiList[index].maxNum = pingunZhi + yushu;
              }
            });
          }

          this.allTaskList = fenpeiList;
        }
      }

      this.fenpei_list = [];
      this.allTaskList.forEach((item) => {
        if (item.selectedState) {
          this.fenpei_list.push(item);
        }
      });

      this.$forceUpdate();
    },
    getTobAllAcCount() {
      commonApi.getTobAllAcCount().then((res) => {
        if (res.code === 200) {
          this.active = 1;
          this.fileName = "";
          this.excelList = [];
          this.returnData = {};

          if (res.data && res.data.length > 0) {
            res.data.forEach((item) => {
              item.selectedState = false;
              item.num = 0;
              item.staff_id = item.id;
              item.name = item.realname;
              item.disabled = false;
            });
            this.allTaskList = res.data;
            this.allTaskList.forEach((item) => {
              item.maxNum = this.returnData.succ;
            });
          }

          console.log("getTobAllAcCount", this.allTaskList);
        }
      });
    },
    nextClick() {
      this.active++;
    },
    show() {
      this.outerVisible = true;
    },
    // 关闭
    handleClose(done) {
      done();
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    backClick() {
      this.active = 1;
      this.fileName = "";
      this.excelList = [];
      this.returnData = {}; 
      this.is_import_repeat_mobile = 0;
      this.old_repeat_excel_data_list = [];
      this.isImportShow = false;
      this.isImportSucc = 0;
      this.onlytimestamp = ""; 
    },

    excelImport() {
      this.fileName = "";
      this.excelList = [];
      this.outerVisible = false;
    },
    // 批量导入
    // 文件选择回调
    onChange(file, fileList) {
      //  fileList);
      this.fileData = file; // 保存当前选择文件
      this.fileName = file.name;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      let that = this;
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          console.log("data---", data);
          const workbook = that.XLSX.read(data, {
            type: "binary",
            // cellNF:true,
            raw: true,
          });
          console.log("workbook---", workbook);
          // if (workbook.SheetNames.length >= 1) {
          //   this.$message.success("表格导入成功")
          // }
          const wsname = workbook.SheetNames[0]; //取第一张表
          console.log("wsname---", wsname);
          const ws = that.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log("ws---", ws);
          that.outputs = []; //清空接收数据
          let _list = [];
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              fullname: ws[i]["姓名（非必填）"],
              mobile: ws[i]["手机号（必填）"],
              score: ws[i]["分数（非必填）"],
              app_type:
                ws[i][
                  "所属考试(非必填，也可选择下列考试名称填写方便系统识别：高职单招考试，成人高考，成人高考高起点考试，成人高考专升本考试)"
                ],
              province: ws[i]["省份（非必填）"],
              city: ws[i]["市（非必填）"],
              remark: ws[i]["备注（非必填）"],
              form_date: ws[i]["表单日期"],
            };
            _list.push(sheetData);
          }
          if (_list.length) {
            this.excelList = _list;
            console.log("this.excelList", this.excelList);
          } else {
            this.$message.error("请先填入数据");
          }

          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    ImportRecord() {
      this.$router.push({
        path: "/importDetalRecord",
      });
    },
    exportExcel() {
      window.open(
        "https://img2.meite.com/questions/202407/036684af235951e.xls",
        "_blank"
      );
      // var titleList = [
      //   { title: '手机号（必填）', key: "mobile" },
      //   { title: '所属考试(可为空，也可选择下列考试名称填写方便系统识别：高职单招考试，成人高考，成人高考高起点考试，成人高考专升本考试)', key: 'apptype' },
      //   { title: '省份（可为空）', key: 'province' },
      //   { title: '市（可为空）', key: 'city' },
      //   { title: '备注（可为空）', key: 'remark' },
      // ]
      // var dataSource = [{ mobile: '15712345678', apptype: '高职单招考试', province: '湖南', city: '长沙', remark: '备考通' }]
      // var fileName = "自有号码导入模版"
      // qee(titleList, dataSource, fileName)
    },
    isImportChange(){ 
        callPhoneApi
          .importCallPhone({
            data: JSON.stringify(this.old_repeat_excel_data_list),
            task_name: this.task_name,
            task_id: this.returnData.task_id,
            is_import_repeat_mobile:1,
            last_onlytimestamp:this.onlytimestamp
          })
          .then((res) => { 
            if (res.code == 200) { 
              this.isImportShow = true;
              this.isImportSucc = res.data.succ;


              this.fileName = "";  
              this.excelList = [];
              this.returnData = res.data
              this.residue = res.data.succ;
              this.Remaining = 0;

              this.$message.success("导入成功!")
            }else { 
              this.isImportShow = false;
              this.isImportSucc = 0;
              this.$message.error(res.message);
              this.is_import_repeat_mobile = 0;
              this.$forceUpdate(); //刷新 
            }
          })    
    },
    importFile() {
      if (this.excelList && this.excelList.length > 0) {
        this.next();
        this.loading = true;
        callPhoneApi
          .importCallPhone({
            data: JSON.stringify(this.excelList),
            task_name: this.task_name,
          })
          .then((res) => {
            this.loading = false;
            if (res.code == 200) {
              // this.$message.success("导入成功，请查看导入记录")
              this.fileName = "";  
              this.excelList = [];
              this.returnData = res.data;
              this.residue = res.data.succ;
              this.Remaining = 0;
              console.log("importCallPhone", res.data);
              this.isImportShow = false;
              this.onlytimestamp = res.data.onlytimestamp;
              this.is_import_repeat_mobile = 0;

              if(res.data.old_repeat_excel_data_list&&res.data.old_repeat_excel_data_list.length>0){ 
                this.old_repeat_excel_data_list = res.data.old_repeat_excel_data_list; 
              }

               
            } else {
              this.backClick();
              this.$forceUpdate(); //刷新
              console.log("importFile");
              this.$message.error(res.message);
            }
          });
      } else {
        this.$message.error("请先导入数据");
      }
    },

    skipImportRecordDetail(recordId) {
      this.$router.push({
        path: "/importRecordDetail",
        query: {
          recordId: recordId,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.querySearch {
  .searchItem {
    display: inline-block;
    margin: 10px;
    span {
      margin-right: 10px;
      font-size: 14px;
    }
    /deep/ .el-input {
      width: 230px;
    }
  }
  /deep/ .el-button--primary {
    margin-left: 20px;
  }
}
/deep/.fileBox {
  padding: 0 100px;
  font-size: 16px;
  .fileH1 {
    margin-bottom: 20px;
  }
  .fileH2 {
    margin-bottom: 20px;
    .fileH2Text {
      margin-bottom: 20px;
    }
  }

  .loadingH1 {
    min-height: 200px;
  }
  .loadingH2 {
    text-align: center;
    min-height: 200px;
    .pic {
      margin: 20px 0;
    }

    .pic:before {
      font-size: 50px;
      color: #409eff;
    }
    .title {
      margin-bottom: 20px;
    }
    .cont {
      margin-bottom: 20px;
    }
  }
}

/deep/.dialog-footer {
  text-align: center;
}
.notice {
  margin: 15px 10px;
}
.bottomStyle {
  text-align: right;
}
/deep/.el-dialog__body {
  padding-top: 0 !important;
  .fileTitle {
    font-size: 18px;
    padding: 0 0 40px 100px;
  }
}
/deep/.el-input-group__append {
  border: 1px solid #dcdfe6 !important;
}
</style>
